<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'app',

  data () {
    return {}
  }/* ,

  watch: {
    '$route' (to, from) {
      debugger
    }
  } */

}
</script>
<style lang="stylus">
  @import './assets/style/base.styl'
</style>
